import { TranslationFunctionType } from '@/common/types';
import { boolean, object, string } from 'yup';

export const ssoSchema = (t: TranslationFunctionType) =>
  object({
    idpEntityId: string().when(
      ['isManual', 'isSSO'],
      ([isManual, isSSO], schema) =>
        isManual && isSSO
          ? schema.required(t('error.requiredField'))
          : schema.notRequired().nullable(),
    ),
    singleSignOnServiceUrl: string().when(
      ['isManual', 'isSSO'],
      ([isManual, isSSO], schema) =>
        isManual && isSSO
          ? schema.required(t('error.requiredField'))
          : schema.notRequired().nullable(),
    ),
    signingCertificate: string().when(
      ['isManual', 'isSSO'],
      ([isManual, isSSO], schema) =>
        isManual && isSSO
          ? schema.required(t('error.requiredField'))
          : schema.notRequired().nullable(),
    ),
    importUrl: string().when(
      ['isManual', 'isSSO'],
      ([isManual, isSSO], schema) =>
        !isManual && isSSO
          ? schema.required(t('error.requiredField'))
          : schema.notRequired().nullable(),
    ),
    displayName: string().nullable(),
    isSSO: boolean(),
    isManual: boolean().default(false),
  });
